import type { ReactNode } from 'react';

export const symbol_stack_star: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m600-293 68 41q5 2 9-.5t3-7.5l-18-78 60-52q4-3 2-7.5t-7-5.5l-79-7-31-74q-1.5-5-6.75-5t-7.25 5l-31 74-79 7q-5 1-7 5.5t2 7.5l60 52-18 78q-1 5 3 7.5t9 .5l68-41Zm-460-27q-24.75 0-42.37-17.63Q80-355.25 80-380v-440q0-24.75 17.63-42.38Q115.25-880 140-880h440q24.75 0 42.38 17.62Q640-844.75 640-820v90q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-90H140v440h90q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5h-90ZM380-80q-24.75 0-42.37-17.63Q320-115.25 320-140v-440q0-24.75 17.63-42.38Q355.25-640 380-640h440q24.75 0 42.38 17.62Q880-604.75 880-580v440q0 24.75-17.62 42.37Q844.75-80 820-80H380Zm0-60h440v-440H380v440Zm220-220Z"
		/>
	</svg>
);
